import type { SiderProps } from "antd";

import { Grid } from "antd";

const { useBreakpoint } = Grid;

export const useStaticLayoutSiderWidth = (): SiderProps["width"] => {
  const { md, lg, xxl } = useBreakpoint();

  if (xxl) return "70%";

  if (lg) return "60%";

  if (md) return "50%";

  return undefined;
};
